module.exports = __webpack_public_path__ + "img/f1.2b058526.png";